export interface BookData {
  title: string;
  cover: string;
  textColor: string;
  pageCount: number;
  coverImage?: string;
  /**
   * Optional video URL (e.g. .mp4 / .webm). When provided, the card cover
   * renders a silent looping video instead of the static image.
   * GIF URLs can also be passed to `coverImage` — they animate by default.
   */
  coverVideo?: string;
}

export const BOOKS: BookData[] = [
  {
    title: 'The Silent\nLibrary',
    cover: '#1a1a1a',
    textColor: 'transparent',
    pageCount: 24,
    coverImage:
      'https://readdy.ai/api/search-image?query=Minimalist%20book%20cover%20design%20deep%20charcoal%20black%20background%20with%20a%20single%20thin%20white%20line%20drawing%20of%20tall%20arched%20library%20shelves%20and%20a%20small%20staircase%2C%20delicate%20serif%20title%20The%20Silent%20Library%20in%20bone%20white%20at%20top%2C%20editorial%20book%20cover%20art%2C%20studio%20photography%2C%20warm%20neutral%20studio%20background%2C%20paper%20texture%20detail&width=400&height=572&seq=foliom-book-silent-library&orientation=portrait',
    coverVideo:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4',
  },
  {
    title: 'Moonlit\nPages',
    cover: '#1f3d5a',
    textColor: 'transparent',
    pageCount: 28,
    coverImage:
      'https://readdy.ai/api/search-image?query=Art%20deco%20book%20cover%20design%20deep%20midnight%20navy%20background%20with%20embossed%20gold%20crescent%20moon%20and%20delicate%20gold%20arch%20patterns%2C%20elegant%20gold%20foil%20serif%20title%20Moonlit%20Pages%2C%20vintage%20celestial%20theme%2C%20editorial%20book%20cover%20photography%2C%20warm%20neutral%20backdrop%2C%20rich%20paper%20grain&width=400&height=572&seq=foliom-book-moonlit-pages&orientation=portrait',
  },
  {
    title: 'Golden\nLetters',
    cover: '#b68b2e',
    textColor: 'transparent',
    pageCount: 22,
    coverImage:
      'https://readdy.ai/api/search-image?query=Art%20deco%20book%20cover%20design%20deep%20black%20background%20with%20bold%20geometric%20gold%20foil%20sunburst%20pattern%2C%20stamped%20gold%20metallic%20serif%20title%20Golden%20Letters%2C%201920s%20typography%20aesthetic%2C%20editorial%20book%20cover%20studio%20photography%2C%20warm%20neutral%20background%2C%20luxe%20vintage%20feel&width=400&height=572&seq=foliom-book-golden-letters&orientation=portrait',
  },
  {
    title: 'Velvet\nStories',
    cover: '#3b244d',
    textColor: 'transparent',
    pageCount: 26,
    coverImage:
      'https://readdy.ai/api/search-image?query=Victorian%20era%20book%20cover%20design%20oil%20painting%20portrait%20of%20a%20woman%20in%20deep%20plum%20velvet%20dress%20holding%20flowers%2C%20ornate%20gold%20serif%20title%20Velvet%20Stories%20at%20top%2C%20classical%20painterly%20style%2C%20editorial%20book%20cover%20photography%2C%20warm%20studio%20backdrop%2C%20rich%20oil%20painting%20texture&width=400&height=572&seq=foliom-book-velvet-stories&orientation=portrait',
    coverVideo:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4',
  },
  {
    title: 'Forest\nNotes',
    cover: '#244d35',
    textColor: 'transparent',
    pageCount: 30,
    coverImage:
      'https://readdy.ai/api/search-image?query=Vintage%20botanical%20book%20cover%20design%20aged%20cream%20paper%20with%20a%20detailed%20Victorian%20scientific%20illustration%20of%20ferns%20and%20pine%20branches%20in%20deep%20moss%20green%20ink%2C%20small%20handset%20serif%20title%20Forest%20Notes%2C%20editorial%20book%20cover%20photography%2C%20warm%20neutral%20background%2C%20natural%20paper%20grain&width=400&height=572&seq=foliom-book-forest-notes&orientation=portrait',
  },
  {
    title: 'Ivory\nDreams',
    cover: '#e8dcc3',
    textColor: 'transparent',
    pageCount: 20,
    coverImage:
      'https://readdy.ai/api/search-image?query=Surrealist%20book%20cover%20design%20soft%20blush%20pink%20cream%20gradient%20background%20with%20floating%20pearls%20and%20pastel%20clouds%2C%20delicate%20dove%20bird%20silhouette%2C%20whisper%20thin%20serif%20title%20Ivory%20Dreams%2C%20dreamy%20editorial%20book%20cover%20photography%2C%20warm%20neutral%20studio%20backdrop%2C%20soft%20paper%20texture&width=400&height=572&seq=foliom-book-ivory-dreams&orientation=portrait',
  },
  {
    title: 'Crimson\nArchive',
    cover: '#8f1f1f',
    textColor: 'transparent',
    pageCount: 25,
    coverImage:
      'https://readdy.ai/api/search-image?query=Vintage%20academic%20book%20cover%20design%20deep%20oxblood%20red%20cloth%20texture%20with%20gold%20embossed%20serial%20number%20and%20small%20ornamental%20border%2C%20stamped%20gold%20serif%20title%20Crimson%20Archive%2C%20old%20library%20university%20press%20feel%2C%20editorial%20book%20cover%20photography%2C%20warm%20studio%20backdrop%2C%20detailed%20cloth%20grain&width=400&height=572&seq=foliom-book-crimson-archive&orientation=portrait',
  },
  {
    title: 'Blue\nEssays',
    cover: '#203f73',
    textColor: 'transparent',
    pageCount: 27,
    coverImage:
      'https://readdy.ai/api/search-image?query=Mid%20century%20modern%20book%20cover%20design%20deep%20cobalt%20blue%20background%20with%20bold%20mustard%20yellow%20geometric%20circles%20and%20rectangles%20composition%2C%20clean%20cream%20sans%20serif%20title%20Blue%20Essays%2C%201960s%20editorial%20aesthetic%2C%20book%20cover%20studio%20photography%2C%20warm%20neutral%20backdrop%2C%20smooth%20paper%20texture&width=400&height=572&seq=foliom-book-blue-essays&orientation=portrait',
  },
  {
    title: 'Paper\nSun',
    cover: '#d97548',
    textColor: 'transparent',
    pageCount: 23,
    coverImage:
      'https://readdy.ai/api/search-image?query=Bauhaus%20book%20cover%20design%20warm%20cream%20background%20with%20bold%20primary%20color%20composition%20red%20circle%20yellow%20triangle%20black%20square%20arrangement%2C%20clean%20geometric%20layout%2C%20bold%20sans%20serif%20title%20Paper%20Sun%20in%20black%2C%20editorial%20book%20cover%20studio%20photography%2C%20warm%20neutral%20backdrop%2C%20visible%20paper%20grain&width=400&height=572&seq=foliom-book-paper-sun&orientation=portrait',
  },
  {
    title: 'Glass\nHours',
    cover: '#2d5c4f',
    textColor: 'transparent',
    pageCount: 26,
    coverImage:
      'https://readdy.ai/api/search-image?query=Art%20nouveau%20book%20cover%20design%20stained%20glass%20pattern%20in%20jewel%20tones%20emerald%20teal%20amber%20rose%2C%20intricate%20flowing%20organic%20lines%2C%20ornamental%20serif%20title%20Glass%20Hours%20at%20top%2C%201900s%20decorative%20aesthetic%2C%20editorial%20book%20cover%20photography%2C%20warm%20neutral%20studio%20backdrop%2C%20rich%20color%20detail&width=400&height=572&seq=foliom-book-glass-hours&orientation=portrait',
    coverVideo:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4',
  },
  {
    title: 'Letters\nHome',
    cover: '#7a5a3e',
    textColor: 'transparent',
    pageCount: 24,
    coverImage:
      'https://readdy.ai/api/search-image?query=Vintage%20sepia%20photographic%20book%20cover%20design%20faded%20portrait%20of%20a%20woman%20writing%20at%20wooden%20desk%20near%20window%20warm%20golden%20light%2C%20soft%20serif%20title%20Letters%20Home%20in%20bone%20white%20bottom%2C%201940s%20memoir%20aesthetic%2C%20editorial%20book%20cover%20photography%2C%20warm%20neutral%20studio%20backdrop%2C%20aged%20paper%20texture&width=400&height=572&seq=foliom-book-letters-home&orientation=portrait',
  },
  {
    title: 'Quiet\nStars',
    cover: '#0f1d3a',
    textColor: 'transparent',
    pageCount: 29,
    coverImage:
      'https://readdy.ai/api/search-image?query=Astronomical%20book%20cover%20design%20deep%20midnight%20indigo%20background%20with%20vintage%20constellation%20map%20in%20fine%20gold%20foil%20lines%20and%20tiny%20star%20points%2C%20elegant%20gold%20serif%20title%20Quiet%20Stars%2C%20celestial%20cartography%20aesthetic%2C%20editorial%20book%20cover%20photography%2C%20warm%20neutral%20backdrop%2C%20paper%20grain%20detail&width=400&height=572&seq=foliom-book-quiet-stars&orientation=portrait',
  },
];